import { __makeTemplateObject, __assign } from 'tslib';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { positioning } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { Box } from '../box/Box.js';

var defaultStyles = {
  backgroundColor: "transparent",
  extra: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    vertical-align: bottom;\n    font-size: 25px;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    box-shadow: inset 0 0 0 0 white;\n    cursor: pointer;\n    font: inherit;\n    height: 1em;\n    outline: none;\n    width: 1em;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n\n    &:checked {\n      background-color: ", ";\n      box-shadow: inset 0 0 0 0.1875em ", ";\n      -webkit-transition: background 0.3s, box-shadow 0.2s;\n      transition: background 0.3s, box-shadow 0.2s;\n    }\n  "], ["\n    vertical-align: bottom;\n    font-size: 25px;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    box-shadow: inset 0 0 0 0 white;\n    cursor: pointer;\n    font: inherit;\n    height: 1em;\n    outline: none;\n    width: 1em;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n\n    &:checked {\n      background-color: ", ";\n      box-shadow: inset 0 0 0 0.1875em ", ";\n      -webkit-transition: background 0.3s, box-shadow 0.2s;\n      transition: background 0.3s, box-shadow 0.2s;\n    }\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.brand;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.brand;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
  })
};
var StyledRadioInput = /*#__PURE__*/styled("input").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Radio__StyledRadioInput",
  componentId: "sc-t8yb9v-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", ";\n"], ["\n  ", "\n  ", ";\n"])), positioning, function (_a) {
  var extra = _a.extra;
  return extra !== null && extra !== void 0 ? extra : extra;
});
var HiddenLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "Radio__HiddenLabel",
  componentId: "sc-t8yb9v-1"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: none;\n  width: 0;\n  height: 0;\n"], ["\n  display: none;\n  width: 0;\n  height: 0;\n"])));
var Radio = function (props) {
  return React__default.createElement(Box, null, React__default.createElement(StyledRadioInput, __assign({}, defaultStyles, props, {
    type: "radio"
  })), React__default.createElement(HiddenLabel, null));
};
var templateObject_1, templateObject_2, templateObject_3;

export { Radio, StyledRadioInput };
//# sourceMappingURL=Radio.js.map
